import React from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Card, CardBody } from "reactstrap";
import { readableDate } from "utils";

interface WeighBillViewModalProps {
  isOpen: boolean;
  toggle: () => void;
  weighBill: any;
}

const WeighBillViewModal = ({ isOpen, toggle, weighBill }: WeighBillViewModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Weigh Bill Details</ModalHeader>
      <ModalBody>
        <Card>
          <CardBody>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <h5 className="font-size-15">Bill ID:</h5>
                  <p className="text-muted">{weighBill?.id}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <h5 className="font-size-15">Date:</h5>
                  <p className="text-muted">{readableDate(weighBill?.created_at)}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <h5 className="font-size-15">Product:</h5>
                  <p className="text-muted">{weighBill?.product_name}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <h5 className="font-size-15">Supplier:</h5>
                  <p className="text-muted">{weighBill?.supplier_name}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <h5 className="font-size-15">Quantity:</h5>
                  <p className="text-muted">{weighBill?.quantity}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <h5 className="font-size-15">Status:</h5>
                  <p className="text-muted">{weighBill?.status}</p>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default WeighBillViewModal; 